module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CG-299647d51aef6889731563ada21354b4.png";